import { Router, UrlTree } from '@angular/router';
import { AppConstants } from '../constants/app.constants';
import parsePhoneNumberFromString from 'libphonenumber-js';
import { AppValidator } from './validator';

export class Utils {
  static delay(ms: number) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  static scrollToTop(ms: number = 300) {
    setTimeout(() => {
      try {
        window.scroll({
          top: 0,
          left: 0,
          behavior: 'smooth',
        });
      } catch (_) {}
    }, ms);
  }

  static getUsernameFromToken(token: string): string {
    try {
      return JSON.parse(atob(token.split('.')[1])).email ?? '';
    } catch (_) {}
    return '';
  }

  static toInt(str: string | undefined | null, defaultValue: number = 0): number {
    try {
      if (str) {
        const num = parseInt(str);
        return Number.isNaN(num) ? defaultValue : num;
      }
    } catch (_) {}
    return defaultValue;
  }

  static getOriginalRouteUrl(router: Router): string {
    try {
      const urlTree = router.parseUrl(router.url);
      return this.getOriginalRouteUrlFromUrlTree(urlTree);
    } catch (_) {}
    return router.url;
  }

  private static getOriginalRouteUrlFromUrlTree(urlTree: UrlTree): string {
    return '/' + urlTree.root.children['primary'].segments.map((it) => it.path).join('/');
  }

  static fileSizeToString(bytes: number, convertByBytes: number = 1000): string {
    if (bytes < convertByBytes) {
      return `${bytes} bytes`;
    }
    if (bytes < convertByBytes * convertByBytes) {
      return `${Math.floor(bytes / convertByBytes)} kb`;
    }
    if (bytes < convertByBytes * convertByBytes * convertByBytes) {
      return `${Math.floor(bytes / (convertByBytes * convertByBytes))} mb`;
    }
    return `${Math.floor(bytes / (convertByBytes * convertByBytes * convertByBytes))} gb`;
  }

  /**
   *
   * @param defaultWidth
   * @param useWindowWidth is used only for coverage testing purposes
   * @param useDocumentElementWidth is used only for coverage testing purposes
   * @param useBodyWidth is used only for coverage testing purposes
   * @returns
   */
  static windowWidth(
    defaultWidth: number = 768,
    useWindowWidth: boolean = true,
    useDocumentElementWidth: boolean = true,
    useBodyWidth: boolean = true,
  ): number {
    try {
      if (useWindowWidth && window.innerWidth) {
        return window.innerWidth;
      }
      if (useDocumentElementWidth && document.documentElement.clientWidth) {
        return document.documentElement.clientWidth;
      }
      if (useBodyWidth && document.body.clientWidth) {
        return document.body.clientWidth;
      }
    } catch (_) {}

    return defaultWidth;
  }

  static isValidPhoneNumber(countryCode: string, phoneNumber: string): boolean {
    const fullNumber = `${countryCode}${phoneNumber}`;
    const parsedNumber = parsePhoneNumberFromString(fullNumber);
    return parsedNumber?.isValid() ?? false;
  }

  static passwordConfirmPasswordChecker(password: string, confirmPassword: string): boolean {
    return password === confirmPassword;
  }
}
